import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CREHANA_PLAYER_TRANSLATION_KEY } from "./constants";
export default /*#__PURE__*/_defineProperty({}, CREHANA_PLAYER_TRANSLATION_KEY, {
  ERROR_VIDEO: 'Ocurrió un error con el video. Por favor, intenta actualizar tu navegador.',
  BACK_LABEL: 'Regresar',
  SEE_MORE: 'Ver más',
  CLOSE: 'Cerrar',
  // LANGUAGE LABELS
  SPANISH: 'Español',
  PORTUGUESE: 'Portugués',
  ENGLISH: 'Inglés',
  // Controlbar
  ADD_NOTE_LABEL: 'Agregar apunte',
  SETTINGS_LABEL: 'Configuración',
  FULLSCREEN_LABEL: 'Pantalla completa',
  FULLSCREEN_DISABLE_LABEL: 'Salir del modo de pantalla completa',
  FULLSCREEN_NOT_AVAILABLE: 'Pantalla completa no disponible',
  PIP_LABEL: 'Reproductor flotante',
  DISABLE_PIP_LABEL: 'Desactivar reproductor flotante',
  MUTE_LABEL: 'Silenciar',
  UNMUTE_LABEL: 'Activar sonido',
  FORWARD_LABEL: 'Adelantar 10 segundos',
  BACKWARD_LABEL: 'Retroceder 10 segundos',
  PLAY_LABEL: 'Reproducir',
  PAUSE_LABEL: 'Pausar',
  REPLAY_LABEL: 'Repetir',
  CC_LABEL: 'Audio y subtítulos',
  // Settings
  SPEED: 'Velocidad',
  QUALITY: 'Calidad de video',
  AUTO_QUALITY: 'Automática',
  AUDIO: 'Audio',
  SUBTITLES: 'Subtítulos',
  DISABLED_SUBTITLES: 'Desactivados',
  BACK_TO_VIDEO: 'Regresar al video',
  AUTOPLAY: 'Reproducción automática',
  SHOW_NOTES: 'Mostrar apuntes',
  // Endscreen
  ENDSCREEN_START_IN: 'empezará en {{count}} segundo',
  ENDSCREEN_START_IN_plural: 'empezará en {{count}} segundos',
  ENDSCREEN_WATCH_NOW: 'Empezar',
  CANCEL: 'Cancelar',
  NEXT_LECTURE: 'Siguiente clase',
  SKIP_VIDEO: 'Ver siguiente clase',
  // Idle screen
  IDLESCREEN_TITLE: 'Hola, ¿sigues ahí?',
  IDLESCREEN_CONTINUE: 'Ver la siguiente clase',
  IDLESCREEN_GO_BACK: 'Regresar al inicio del módulo',
  IDLESCREEN_IGNORE: 'No volver a mostrar',
  // Confirmation overlay
  CONFIRMATION_TITLE_W_NAME: '{{name}}, te falta poco para terminar',
  CONFIRMATION_TITLE: 'Te falta poco para terminar',
  CONFIRMATION_DETAIL: 'Tan solo falta {{minutes}} para que completes esta clase',
  CONFIRMATION_LEAVE: 'Salir de la clase',
  CONFIRMATION_CONTINUE: 'Seguir viendo la clase',
  // Quality warnings
  HD: 'HD',
  RECOMMENDED: 'recomendada',
  LOW_QUALITY_WARNING_TITLE: 'Tu calidad de video es baja',
  LOW_QUALITY_WARNING_DESCRIPTION: 'Reducimos la calidad porque la conexión es lenta, es probable que las imágenes no se vean nítidas.',
  LOW_QUALITY_WARNING_CTA: 'Ajusta la calidad en este ícono',
  MANUAL_HIGH_QUALITY_WARNING_TITLE: '¡Mejoraste tu calidad de video!',
  MANUAL_HIGH_QUALITY_WARNING_DESCRIPTION: 'Recuerda que, si tu **velocidad de conexión es lenta**, tus clases podrían **demorar en cargar**.',
  MANUAL_HIGH_QUALITY_WARNING_CTA: 'Puedes configurar la calidad cuantas veces quieras en este ícono',
  // Error overlay
  ERROR_TITLE: 'Tenemos dificultades para reproducir este video',
  AI_LABEL: 'Apuntes con AI',
  AI_SUCCESS_TITLE: 'Has guardado todos los apuntes generados',
  AI_SUCCESS_SUBTITLE: 'Puedes generar apuntes nuevamente si lo deseas.',
  AI_LABEL_TITLE: 'Apuntes de clase',
  AI_LABEL_TITLE_LONG: 'Apuntes de clase con AI',
  AI_LOADING: 'Estamos generando tu resumen de la clase con inteligencia artificial',
  AI_SKIP_BUTTON_LABEL: 'Generar apuntes',
  AI_SUCCESS_LABEL: 'Iniciar siguiente clase',
  AI_TAG: 'Beta',
  AI_ERROR_TITLE: 'Se produjo un error al generar los apuntes',
  AI_ERROR_SUBTITLE: 'Inténtalo nuevamente.',
  AI_SUCCESS_TOAST_TITLE: 'Tus apuntes se guardaron correctamente',
  AI_SUCCESS_TOAST_SUBTITLE: 'Los encontrarás en la sección de apuntes dentro del salón de clase',
  AI_DESCRIPTION_SHORT: 'Genera resumen después de cada clase con AI para reforzar tus conocimientos.',
  AI_SUGGESTIONS_DESCRIPTION: 'Selecciona una idea y con el botón guardar, añádela a tu sección apuntes, donde podrás editarla desde ahi.',
  AI_DESCRIPTION: 'Al finalizar cada clase podrás generar un resumen con nuestra inteligencia artificial para que refuerces tus conocimientos.',
  AI_CTA_BUTTON: 'Generar apuntes',
  AI_CTA_BUTTON_SAVE: 'Guardar',
  AI_CTA_NEW_BUTTON: 'Generar nuevo apunte',
  AI_SUCCES_LABEL: 'Entendido',
  AI_LABEL_SUGGESTED: 'Apuntes sugeridos',
  CUSTOM_GENERATE_AI: 'Son generados por una inteligencia artificial para ayudarte a comprender mejor tus video clases. [Más información](https://ayuda.crehana.com/)',
  CUSTOM_GENERATE_AI1: 'Utiliza los apuntes como herramienta de estudio, pero no como sustituto, revisa las clases primero.',
  CUSTOM_GENERATE_AI2: 'La versión "beta", se ofrece a un grupo limitado de usuarios para recibir comentarios y mejorarla antes de su lanzamiento oficial.',
  ERROR_DESC: 'Te recomendamos actualizar tu navegador o volver a intentarlo más tarde.',
  // Key names
  SPACE: 'espacio',
  ARROW_UP: 'flecha arriba',
  ARROW_DOWN: 'flecha abajo',
  M: 'm',
  ARROW_LEFT: 'flecha izquierda',
  ARROW_RIGHT: 'flecha derecha',
  F: 'f',
  A: 'a'
});